/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateUgcContactRequestJobMutationRequest,
  CreateUgcContactRequestJobMutationResponse,
  CreateUgcContactRequestJob400,
} from '../types/CreateUgcContactRequestJob'

function getCreateUgcContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/ugc/` as const }
  return res
}

/**
 * @description Generic view that other views can inherit from to reuse the same filtering/sorting logic
 * @summary Create a contact request job for user-generated (custom) companies
 * {@link /api/v1/contact_request/ugc/}
 */
export async function createUgcContactRequestJob(
  data: CreateUgcContactRequestJobMutationRequest,
  config: Partial<RequestConfig<CreateUgcContactRequestJobMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateUgcContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateUgcContactRequestJob400>,
    CreateUgcContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateUgcContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
